export const MIN_PW_SIZE = 8
